import PropTypes from 'prop-types';

import { Box, Chip, Grid, Typography } from '@mui/material';
import { yellow } from '@mui/material/colors';

import ApartmentIcon from '@mui/icons-material/Apartment';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SchoolIcon from '@mui/icons-material/School';
import ThreePIcon from '@mui/icons-material/ThreeP';

import { createStars } from 'utils/schoolUtils';

StarsComponent.propTypes = {
  mdAuto: PropTypes.bool,
  rating: PropTypes.instanceOf(Object).isRequired,
};

StarsComponent.defaultProps = {
  mdAuto: true,
};

export default function StarsComponent({ mdAuto, rating }) {
  const labels = [
    {
      icon: <SchoolIcon color="primary" />,
      title: 'Escola',
      rating: rating?.school,
    },
    {
      icon: <ApartmentIcon color="primary" />,
      title: 'Infraestrutura',
      rating: rating?.infrastructure,
    },
    {
      icon: <MenuBookIcon color="primary" />,
      title: 'Curso',
      rating: rating?.course,
    },
    {
      icon: <ThreePIcon color="primary" />,
      title: 'Metodologia',
      rating: rating?.teachingMethodology,
    },
  ];

  return (
    <Grid container justifyContent="center" spacing={3}>
      {labels.map((label, index) => (
        <Grid
          item
          key={`${label} - ${index}`}
          xs={12}
          md={mdAuto || 6}
          sx={
            !mdAuto
              ? {
                  display: 'flex',
                  justifyContent: {
                    xs: 'center',
                    md: index % 2 === 0 ? 'flex-end' : 'flex-start',
                  },
                }
              : {}
          }
        >
          <Chip
            icon={label?.icon}
            label={
              <Box alignItems="center" display="flex" gap={1}>
                <Typography fontWeight={700} variant="body1">
                  {label?.title}
                </Typography>

                <Box alignItems="center" display="flex">
                  {createStars(label?.rating, yellow[800])}
                </Box>
              </Box>
            }
            sx={{
              justifyContent: { xs: 'flex-start', md: 'inline-flex' },
              px: 1,
              width: mdAuto ? { xs: '100%' } : { xs: '100%', md: 'auto' },
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
